// extracted by mini-css-extract-plugin
export default {"content":"AddNoteForm_content__uKM8M","actions":"AddNoteForm_actions__dLe8Q","normalButton":"AddNoteForm_normalButton__cJJzh"};